<template>
<v-container>
    <v-layout row wrap>

        <v-flex xs12 xl10 offset-xl1 my-5>
            <v-layout align-baseline justify-space-between px-2 wrap>
                <div>
                    <h1 class="display-2 pb-2">{{ parent.first_name }} {{ parent.last_name }}</h1>
                    <p class="body-2 red--text">Below is a table of your children/students. Use the table to see current schedules and sign up for classes.</p>
                </div>
                <v-btn @click="addStudentDialog = true" class="primary mt-4">Add Student</v-btn>
            </v-layout>
            <v-divider class="mb-3"></v-divider>
        </v-flex>

        <v-flex xs12 xl10 offset-xl1>
            <v-alert transition="fade-transition" v-model="studentSuccessfullyAdded" dismissible type="success">Student successfully added!</v-alert>
        </v-flex>

        <v-flex xs12 xl10 offset-xl1>
            <v-alert transition="fade-transition" v-model="studentSuccessfullyUpdated" dismissible type="success">Student successfully updated!</v-alert>
        </v-flex>

        <v-flex xs12 xl10 offset-xl1 mb-5>
            <v-data-table :headers="headers" :items="parent.students" hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td class="text-xs-left">{{ props.item.first_name }}</td>
                        <td class="text-xs-left">{{ props.item.last_name }}</td>
                        <td class="text-xs-left">{{ props.item.grade }}</td>
                        <td class="text-xs-center">
                            <v-btn @click="initEditStudent(props.item)" small color="primary" class="elevation-0">Edit</v-btn>
                            <!-- <a @click="initEditStudent(props.item)">Edit</a> -->
                        </td>
                        <td class="text-xs-center">
                            <v-btn @click="showSchedule(props.item)" small color="primary" class="elevation-0" :disabled="props.item.grade === 'done'">View</v-btn>
                            <!-- <a @click="showSchedule(props.item.id)">View</a> -->
                        </td>
                        <td class="text-xs-center">
                            <v-btn @click="manageClasses(props.item)" small color="primary" class="elevation-0" :disabled="props.item.grade === 'done'">Add/Drop Classes</v-btn>
                            <!-- <a @click="manageClasses(props.item)">Add/Drop Classes</a> -->
                        </td>
                    </tr>
                </template>
                <template slot="no-data">
                    <v-alert :value="true" color="error" icon="warning">
                        Looks like you don't have any children, click "ADD STUDENT" above to add some!
                    </v-alert>
                </template>
            </v-data-table>
        </v-flex>

        <v-dialog v-model="addStudentDialog" max-width="500px">
            <create-student-form :active="addStudentDialog" :parent_id="parent.id" @success="studentSuccessfullyAdded = true" @close="addStudentDialog = false">
            </create-student-form>
        </v-dialog>

        <v-dialog v-model="editStudentDialog" max-width="500px">
            <edit-student-form :active="editStudentDialog" :studentData="selectedStudentData" @success="studentSuccessfullyUpdated = true" @close="editStudentDialog = false">
            </edit-student-form>
        </v-dialog>

        <v-dialog v-model="showStudentScheduleDialog" max-width="1080px">
            <v-card>
                <v-flex xs12 pa-3>
                    <student-schedule :active="showStudentScheduleDialog" :student="selectedStudentData"></student-schedule>
                </v-flex>
                <!-- <v-card-actions>
            <v-btn color="primary" @click.stop="showStudentScheduleDialog = false">Close</v-btn>
          </v-card-actions> -->
            </v-card>
        </v-dialog>

    </v-layout>
</v-container>
</template>

<script>
import StudentSchedule from './StudentSchedule'
import CreateStudent from './CreateStudent'
import EditStudent from './EditStudent'

export default {
    components: {
        StudentSchedule,
        CreateStudentForm: CreateStudent,
        EditStudentForm: EditStudent
    },
    data() {
        return {
            addStudentDialog: false,
            editStudentDialog: false,
            selectedStudentData: {},
            studentSuccessfullyAdded: false,
            studentSuccessfullyUpdated: false,
            showStudentScheduleDialog: false,
            headers: [{
                    text: 'First name',
                    align: 'left',
                    value: 'first_name',
                    width: '20%'
                },
                {
                    text: 'Last name',
                    align: 'left',
                    value: 'last_name',
                    width: '20%'
                },
                {
                    text: 'Grade',
                    align: 'left',
                    value: 'grade',
                    width: '10%'
                },
                {
                    text: 'Update',
                    align: 'center',
                    value: 'edit',
                    width: '15%'
                },
                {
                    text: 'Schedule',
                    align: 'center',
                    value: 'schedule',
                    width: '15%'
                },
                {
                    text: 'Manage',
                    align: 'center',
                    value: 'dropadd',
                    width: '20%'
                },
            ],
            grades: [{
                    text: 'Kindergarten',
                    value: 'K'
                },
                {
                    text: '1st',
                    value: '1'
                },
                {
                    text: '2nd',
                    value: '2'
                },
                {
                    text: '3rd',
                    value: '3'
                },
                {
                    text: '4th',
                    value: '4'
                },
                {
                    text: '5th',
                    value: '5'
                },
                {
                    text: '6th',
                    value: '6'
                },
                {
                    text: '7th',
                    value: '7'
                },
                {
                    text: '8th',
                    value: '8'
                },
                {
                    text: '9th',
                    value: '9'
                },
                {
                    text: '10th',
                    value: '10'
                },
                {
                    text: '11th',
                    value: '11'
                },
                {
                    text: '12th',
                    value: '12'
                }
            ]
        }
    },
    created() {
        this.$store.dispatch('getSemesters')
    },
    computed: {
        parent() {
            return this.$store.state.auth.user
        },
    },
    methods: {
        initEditStudent(student) {
            this.editStudentDialog = true
            this.selectedStudentData = Object.assign({}, student)
        },
        showSchedule(student) {
            this.showStudentScheduleDialog = true
            this.selectedStudentData = Object.assign({}, student)
        },
        manageClasses(student) {
            this.$store.commit('setEnrollmentStudent', student)
            this.$router.push('/enrollment')
            // future refactor - try and pass params to enrollment route, e.g. /enrollment?id=4, but make sure route is protected
            // this.$store.dispatch('getStudentSchedule', student.id).then(() => this.$router.push('/enrollment'))
        }
    }
}
</script>
